import React from "react";
import {
  Divider,
  Fade,
  FormControlLabel,
  Grid,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

const SortQuizzesMenu = ({
  anchorEl,
  open,
  handleCloseMenu,
  classes,
  sortOption,
  handleSortOptionChange,
  handleSortQuiz,
}) => {
  return (
    <Menu
      id="sort-menu"
      MenuListProps={{
        "aria-labelledby": "sort-button",
      }}
      anchorEl={anchorEl}
      open={open}
      onClose={handleCloseMenu}
      TransitionComponent={Fade}
      className={classes.customWidth}
    >
      <Grid container alignItems="center">
        <Grid item xs={8}>
          <span className={classes.sortTitle}>Sort By</span>
        </Grid>
        <Grid item xs={4} style={{ textAlign: "end" }}>
          <CloseIcon
            onClick={handleCloseMenu}
            style={{ marginRight: 10, cursor: "pointer" }}
          />
        </Grid>
      </Grid>
      <Divider />
      <MenuItem onClick={() => handleSortQuiz("Name")}>
        <span className={classes.sortItems}>Name</span>
      </MenuItem>
      <MenuItem onClick={() => handleSortQuiz("Date Joined")}>
        <span className={classes.sortItems}>Date Joined</span>
      </MenuItem>
      <MenuItem onClick={() => handleSortQuiz("No. of Questions")}>
        <span className={classes.sortItems}>Number of Questions</span>
      </MenuItem>
      <MenuItem
        onClick={() => handleSortQuiz("All")}
        style={{ marginBottom: 10 }}
      >
        <span className={classes.sortItems}>All</span>
      </MenuItem>
      <Divider />
      <RadioGroup value={sortOption} onChange={handleSortOptionChange}>
        <FormControlLabel
          value="Ascending"
          control={<Radio />}
          label="Ascending"
        />
        <FormControlLabel
          value="Descending"
          control={<Radio />}
          label="Descending"
        />
      </RadioGroup>
    </Menu>
  );
};

export default SortQuizzesMenu;
